import { GetDefaultChecklistDto } from './get-default-checklist-dto.interface';
export interface TranslatedChecklist extends Omit<GetDefaultChecklistDto, 'name' | 'tasks'> {
    name: string;
    tasks?: string[];
    disableSelection: boolean;
}
